import React from "react";
import { CgCloseO } from "react-icons/cg";
import { MdAddToPhotos } from "react-icons/md";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";

import "react-bootstrap-typeahead/css/Typeahead.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../component/common/Loader";

import { Typeahead } from "react-bootstrap-typeahead";
import { addMedicalClaim, checkFileNumber } from "../../actions/FileAction";
import { getMedicalCategoryList } from "../../actions/MasterAction";
import { updateHrDealingOfficer } from "../../actions/UserAction";
import { autoSave } from "../../actions/eDraftAction";
import ModalWindow from "../../component/common/ModalWindow";
import CONSTANT from "../../constant";
import {
  getCookie,
  getStorage,
  onChange,
  removeCurrencySymbol,
  setOptions,
  validateForm,
} from "../../utils";
import PatientName from "./PatientName";

import "./../../assets/css/dltFiles.css";
import "./../../assets/css/medical.css";
import {
  anaesthesiaChargesFiles,
  chronicFile,
  consultationChargesFiles,
  dentalChargesFiles,
  disposalChargesFiles,
  injectionChargesFiles,
  medicineCostFiles,
  operationChargesFiles,
  operationTheatreChargesFiles,
  otherChargesFiles,
  pathologicalChargesFiles,
  physiothrapyChargesFiles,
  roomIcuChargesFiles,
  specialFile,
} from "./chargesFiles";

import constant from "../../constant";

class AddMedicalClaim extends React.Component {
  constructor(props) {
    super(props);
    this.chronicRef = React.createRef();

    const proposal = getStorage("propsal");
   
    this.state = {
      categoryValue: {
        name: "categoryValue",
        value: "",
        error: "",
        isRequired: true,
      },
      categoryList: {
        name: "categoryList",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      attachments: {
        name: "attachments",
        value: [],
        error: "",
        isRequired: false,
      },
      cronicFile: {
        name: "cronicFile",
        value: "",
        error: [],
        isRequired: false,
      },
      specialFile: {
        name: "specialFile",
        value: "",
        error: [],
        isRequired: false,
      },

      department: {
        name: "department",
        value: [],
        error: "",
        isRequired: false,
        options: [],
      },
      diagnosis: {
        name: "diagnosis",
        value: "",
        error: "",
        isRequired: true,
        options: [],
      },
      userDetail: {
        name: "userDetail",
        value: getCookie(CONSTANT.cookie.userDetail),
        error: "",
        isRequired: true,
        options: [],
      },

      patientNames: {
        name: "patientNames",
        value: [],
        error: "",
        isRequired: true,
        options: [],
      },
      bankAccount: {
        name: "bankAccount",
        value: "",
        error: "",
        isRequired: true,
      },
      bankName: { name: "bankName", value: "", error: "", isRequired: true },
      ifsc: { name: "ifsc", value: "", error: "", isRequired: true },

      consultationCharges: {
        name: "consultationCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      consultationChargesFiles: {
        name: "consultationChargesFiles",
        value: "",
        options: "",
        error: "",
        isRequired: false,
      },

      medicineCost: {
        name: "medicineCost",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      medicineCostFiles: {
        name: "medicineCostFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      pathologicalCharges: {
        name: "pathologicalCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      pathologicalChargesFiles: {
        name: "pathologicalChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      physiothrapyCharges: {
        name: "physiothrapyCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      physiothrapyChargesFiles: {
        name: "physiothrapyChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      operationCharges: {
        name: "operationCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      operationChargesFiles: {
        name: "operationChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      operationTheatreCharges: {
        name: "operationTheatreCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      operationTheatreChargesFiles: {
        name: "operationTheatreChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      anaesthesiaCharges: {
        name: "anaesthesiaCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      anaesthesiaChargesFiles: {
        name: "anaesthesiaChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      roomIcuCharges: {
        name: "roomIcuCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      roomIcuChargesFiles: {
        name: "roomIcuChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      injectionCharges: {
        name: "injectionCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      injectionChargesFiles: {
        name: "injectionChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      disposalCharges: {
        name: "disposalCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      disposalChargesFiles: {
        name: "disposalChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      dentalCharges: {
        name: "dentalCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      dentalChargesFiles: {
        name: "dentalChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      otherCharges: {
        name: "otherCharges",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      otherChargesFiles: {
        name: "otherChargesFiles",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },

      totalSum: 0,
      description: {
        name: "description",
        value: "",
        error: "",
        isRequired: false,
      },

      to: { name: "to", value: [], options: [], error: "", isRequired: true },

      showLoader: false,
      isFileNumberValid: undefined,
      showModal: false,

      // userDetail
    };
  }

  addTotal = (e) => {
    if (e.target.value != "") {
      let total = this.state.totalSum + removeCurrencySymbol(e.target.value);
      this.setState({ totalSum: total });
    }

    //  onChange (this , this.state.totalSum.name , total )
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.fileDetail;

    updateHrDealingOfficer().then((res) => {
      if (res.status === CONSTANT.static.apiStatus.success) {
        setOptions(
          this,
          this.state.to.name,
          getStorage(CONSTANT.cookie.hrDealingOfficerList)
        );
      } else {
        alert(res.error);
      }
    });

    getMedicalCategoryList().then((res) => {
      setOptions(this, this.state.categoryList.name, res.result);
    });
  }

  render() {
    const {
      to,

      diagnosis,
      patientNames,
      showModal,
      categoryList,
      categoryValue,
    } = this.state;
    const { showLoader } = this.state;
    let extArray = ["pdf", "png", "jpeg"];

    return (
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-md-2 px-0">
            <Header />
          </div> */}

          <div className="col-md-12">
            <div className="card homedob p-4 mb-4">
            <div className="row my-3">
              <div className="col-md-8">
                <h1 className="page-title"> Add Medical </h1>
              </div>
              <div className="col-md-4">
                <Link
                  to={CONSTANT.component.userFileList.url}
                  className="btn btn-sm submit-button float-right"
                >
                  Go Back
                </Link>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>
                            {" "}
                            Category <small>*</small>
                          </label>

                          <select
                            className={
                              this.state.categoryList.error.length > 0
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name={this.state.categoryList.name}
                            value={this.state.categoryList.value}
                            onChange={this.onChange}
                          >
                            <option> --------- </option>

                            {this.state.categoryList.options.map(function (
                              item,
                              index
                            ) {
                              return (
                                <option key={index} value={item.id}>
                                  {" "}
                                  {item.category}{" "}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-10">
                        <div className="flex justify-content-center align-items-center flex-wrap pt-4">
                        <div className="category_list p-0 m-0">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="flexCheckChecked"
                              disabled={categoryList.value == "" ? true : false}
                              name={categoryValue.name}
                              onChange={this.onChange}
                              value="NORMAL"
                            />
                            <label className="form-check-label" />
                            Normal
                          </div>
                        </div>

                        <div
                          className="category_list p-0 m-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            alignItems: "center",
                          }}
                        >
                          <div className="verticallyAllign">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="flexCheckChecked"
                                disabled={
                                  categoryList.value == "" ? true : false
                                }
                                name={categoryValue.name}
                                onChange={this.onChange}
                                value={"CRONIC"}
                              />
                              <label className="form-check-label" />
                              Cronic
                            </div>
                          </div>

                          <div>
                            <input
                              type="file"
                              name={this.state.cronicFile.name}
                              onChange={this.onChange}
                              style={{ display: "none" }}
                              ref="chronicFileRef"
                              disabled={categoryList.value == "" ? true : false}
                            />
                            <button
                              onClick={() => this.refs.chronicFileRef.click()}
                            >
                              {" "}
                              <span className="badge badge-success">
                                {" "}
                                Upload File{" "}
                              </span>{" "}
                            </button>
                          </div>
                        </div>

                        <div
                          className="category_list p-0 m-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            alignItems: "center",
                          }}
                        >
                          <div className="verticallyAllign">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="flexCheckChecked"
                                disabled={
                                  categoryList.value == "" ? true : false
                                }
                                name={categoryValue.name}
                                onChange={this.onChange}
                                value={"SPECIAL"}
                              />
                              <label className="form-check-label" />
                              Special
                            </div>
                          </div>

                          <div>
                            <input
                              type="file"
                              name={this.state.specialFile.name}
                              onChange={this.onChange}
                              style={{ display: "none", float: "left" }}
                              ref="specialFileRef"
                              disabled={categoryList.value == "" ? true : false}
                            />
                            <button
                              onClick={() => this.refs.specialFileRef.click()}
                            >
                              {" "}
                              <span className="badge badge-success">
                                {" "}
                                Upload File{" "}
                              </span>{" "}
                            </button>
                          </div>
                        </div>

                        <div className="category_list p-0 m-0">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="flexCheckChecked"
                              disabled={categoryList.value == "" ? true : false}
                              name={categoryValue.name}
                              onChange={this.onChange}
                              value={"INDOOR"}
                            />
                            <label className="form-check-label" />
                            Indoor
                          </div>
                        </div>

                        <div className="category_list p-0 m-0">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="flexCheckChecked"
                              disabled={
                                categoryList.value == "" ||
                                categoryList.value == 1
                                  ? true
                                  : false
                              }
                              name={categoryValue.name}
                              onChange={this.onChange}
                              value={"DENTAL"}
                            />
                            <label className="form-check-label" />
                            Dental <sup> Applicable only for Retired </sup>
                          </div>
                        </div>
                        </div>
                      </div>

                      <div className="container ">
                        <div class="row">
                          {this.state.cronicFile.value != "" ? (
                            <div className="col-md-6 col-6">
                              <strong> Cronic Files</strong>{" "}
                              {this.state.cronicFile.value != "" ? (
                                <span class="badge badge-primary">
                                  {this.state.cronicFile.value[0].name}
                                  <CgCloseO
                                    style={{
                                      float: "right",
                                      justifyContent: "Center",
                                      marginLeft: "3px",
                                    }}
                                    title="delete chronic file"
                                    className="closeButton"
                                    onClick={(e) =>
                                      onChange(
                                        this,
                                        this.state.cronicFile.name,
                                        ""
                                      )
                                    }
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            ""
                          )}

                          {this.state.specialFile.value != "" ? (
                            <div className="col-md-6 col-6">
                              <strong> Special File </strong>

                              {this.state.specialFile.value != "" ? (
                                <span class="badge badge-primary">
                                  {this.state.specialFile.value[0].name}
                                  <CgCloseO
                                    style={{
                                      float: "right",
                                      justifyContent: "Center",
                                      marginLeft: "3px",
                                    }}
                                    title="delete special file"
                                    className="closeButton"
                                    onClick={(e) =>
                                      onChange(
                                        this,
                                        this.state.specialFile.name,
                                        ""
                                      )
                                    }
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div class="row marginTop">
                          <div className="col-md-6 col-6">
                            <div className="form-group">
                              <label>
                                Name and Designation <small>*</small>
                              </label>
                              <input
                                className={
                                  this.state.userDetail.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                // name={}
                                value={this.state.userDetail.value.name}
                                // onChange={""}
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-6">
                            <div className="form-group">
                              <label>
                                Diagnosis <small>*</small>
                              </label>

                              <textarea
                                className={
                                  diagnosis.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                name={diagnosis.name}
                                value={diagnosis.value}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div
                            className="col-md-12 col-12"
                            style={{ margin: "10px 0 10px 0 " }}
                          >
                            <button onClick={this.onShowModal}>
                              {" "}
                              <strong> ADD PATEINTS </strong>
                              <MdAddToPhotos
                                style={{ float: "right", marginRight: "5px" }}
                              />{" "}
                            </button>
                            {patientNames && patientNames.value.length > 0
                              ? patientNames.value.map((item, index) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        class="badge badge-secondary dltPatient dltButton"
                                        style={{ margin: "3px" }}
                                      >
                                        {item}{" "}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete patient"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.dltPatient(item, index)
                                          }
                                        />{" "}
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        <div class="row">
                          <div className="col-md-4 col-4">
                            <div className="form-group">
                              <label>
                                Account Number <small>*</small>
                              </label>
                              <input
                                type="text"
                                className={
                                  this.state.bankAccount.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder="****************"
                                name={this.state.bankAccount.name}
                                value={this.state.bankAccount.value}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-4">
                            <div className="form-group">
                              <label>
                                {" "}
                                IFC Code <small>*</small>
                              </label>

                              <input
                                maxLength={11}
                                type="text"
                                className={
                                  this.state.ifsc.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder=""
                                name={this.state.ifsc.name}
                                value={this.state.ifsc.value}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-4">
                            <div className="form-group">
                              <label>
                                Name of the Bank <small>*</small>
                              </label>
                              <input
                                type="text"
                                className={
                                  this.state.bankName.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder=""
                                name={this.state.bankName.name}
                                value={this.state.bankName.value}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="fomr-group">
                          <label>
                            {" "}
                            <strong>
                              {" "}
                              Particulars of Reimbirsment Claimed
                            </strong>{" "}
                          </label>
                        </div>

                        {/* Consulatation charges */}

                        <div className="row">
                          <div className="col-md-4">
                            I. Consulatation charges
                          </div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.consultationCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Consultation charges"
                              name={this.state.consultationCharges.name}
                              value={this.state.consultationCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.consultationChargesFiles.error
                                  .length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              name={this.state.consultationChargesFiles.name}
                              // value={this.state.consultationChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>
                          <div className="container">
                            {this.state.consultationChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.consultationChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.consultationChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.consultationChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <span
                                      className={` mx-1  badge ${
                                        extArray.indexOf(
                                          item.name.split(".").slice(-1)[0]
                                        ) > -1
                                          ? "badge-primary"
                                          : "badge-danger"
                                      } `}
                                    >
                                      {item.name}
                                      <CgCloseO
                                        style={{
                                          float: "right",
                                          justifyContent: "Center",
                                          marginLeft: "3px",
                                        }}
                                        title=" delete special file "
                                        className=" closeButton "
                                        onClick={(e) =>
                                          this.chargesDelete(
                                            this.state.consultationChargesFiles
                                              .name,
                                            index,
                                            array
                                          )
                                        }
                                      />
                                    </span>
                                  );
                                })}
                              </React.Fragment>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        {/* Consulatation charges */}

                        {/* cost of medicine start */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">II. Medicine Cost</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.medicineCost.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Medicine Cost"
                              name={this.state.medicineCost.name}
                              value={this.state.medicineCost.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>
                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.medicineCostFiles.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.medicineCostFiles.name}
                              // value={this.state.medicineCostFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.medicineCostFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.medicineCostFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.medicineCostFiles.value != ""
                              ? Array.from(
                                  this.state.medicineCostFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.medicineCostFiles.name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* cost of medicine end */}

                        {/* Pathological Charges starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">
                            III. Pathological Charges
                          </div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.pathologicalCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="pathologicalCharges"
                              name={this.state.pathologicalCharges.name}
                              value={this.state.pathologicalCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.pathologicalChargesFiles.error
                                  .length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.pathologicalChargesFiles.name}
                              // value={this.state.pathologicalChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.pathologicalChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.pathologicalChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.pathologicalChargesFiles.value != ""
                              ? Array.from(
                                  this.state.pathologicalChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state
                                                .pathologicalChargesFiles.name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* Pathological Charges ends*/}

                        {/* Physiothrapy charges starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">
                            IV. Physiothrapy Charges
                          </div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.physiothrapyCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="physiothrapyCharges"
                              name={this.state.physiothrapyCharges.name}
                              value={this.state.physiothrapyCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.physiothrapyChargesFiles.error
                                  .length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.physiothrapyChargesFiles.name}
                              // value={this.state.physiothrapyChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.physiothrapyChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.physiothrapyChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.physiothrapyChargesFiles.value != ""
                              ? Array.from(
                                  this.state.physiothrapyChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state
                                                .physiothrapyChargesFilesesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* Physiothrapy charges starts ends*/}

                        {/* operationCharges charges starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">IV. Operation Charges</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.operationCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Operational Charges"
                              name={this.state.operationCharges.name}
                              value={this.state.operationCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.operationChargesFiles.error.length >
                                0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.operationChargesFiles.name}
                              // value={this.state.operationChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.operationChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.operationChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.operationChargesFiles.value != ""
                              ? Array.from(
                                  this.state.operationChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.operationChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* operationCharges  starts ends*/}

                        {/* operationTheatreCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">
                            V. OperationTheatre Charges
                          </div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.operationCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="OperationTheatre "
                              name={this.state.operationTheatreCharges.name}
                              value={this.state.operationTheatreCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.operationTheatreChargesFiles.error
                                  .length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={
                                this.state.operationTheatreChargesFiles.name
                              }
                              // value={this.state.operationTheatreChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.operationTheatreChargesFiles.value !=
                            "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.operationTheatreChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.operationTheatreChargesFiles.value != ""
                              ? Array.from(
                                  this.state.operationTheatreChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state
                                                .operationTheatreChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* operationCharges  starts ends*/}

                        {/* anaesthesiaCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">
                            VII. Anaesthesia Charges
                          </div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.anaesthesiaCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="anaesthesiaCharges"
                              name={this.state.anaesthesiaCharges.name}
                              value={this.state.anaesthesiaCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.anaesthesiaChargesFiles.error
                                  .length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.anaesthesiaChargesFiles.name}
                              // value={this.state.anaesthesiaChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.anaesthesiaChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.anaesthesiaChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.anaesthesiaChargesFiles.value != ""
                              ? Array.from(
                                  this.state.anaesthesiaChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.anaesthesiaChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* anaesthesiaCharges   ends*/}

                        {/* roomIcuCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">VIII. Room/ICU Charges</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.roomIcuCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Room/ICU Charges"
                              name={this.state.roomIcuCharges.name}
                              value={this.state.roomIcuCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.roomIcuChargesFiles.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.roomIcuChargesFiles.name}
                              // value={this.state.roomIcuChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.roomIcuChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.roomIcuChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.roomIcuChargesFiles.value != ""
                              ? Array.from(
                                  this.state.roomIcuChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.roomIcuChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* roomIcuChargesFiles   ends*/}

                        {/* injectionCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">IX. Injection Charges</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.injectionCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Injection Charges"
                              name={this.state.injectionCharges.name}
                              value={this.state.injectionCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.injectionChargesFiles.error.length >
                                0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.injectionChargesFiles.name}
                              // value={this.state.injectionChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.injectionChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.injectionChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.injectionChargesFiles.value != ""
                              ? Array.from(
                                  this.state.injectionChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.injectionChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* injectionChargesFiles   ends*/}

                        {/* disposalCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">X. Disposal Charges</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.disposalCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Disposal Charges"
                              name={this.state.disposalCharges.name}
                              value={this.state.disposalCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.disposalChargesFiles.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.disposalChargesFiles.name}
                              // value={this.state.disposalChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.disposalChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.disposalChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.disposalChargesFiles.value != ""
                              ? Array.from(
                                  this.state.disposalChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.disposalChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* disposalChargesFiles   ends*/}

                        {/* dentalCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">XI. Dental Charges</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.dentalCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Dental Charges"
                              name={this.state.dentalCharges.name}
                              value={this.state.dentalCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.dentalChargesFiles.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.dentalChargesFiles.name}
                              // value={this.state.dentalChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.dentalChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.dentalChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.dentalChargesFiles.value != ""
                              ? Array.from(
                                  this.state.dentalChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.dentalChargesFiles
                                                .name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* dentalChargesFiles   ends*/}

                        {/* otherCharges  starts */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">XII. OtherCharges</div>

                          <div className="col-md-4">
                            <NumberFormat
                              prefix={constant.static.currencySymbol}
                              thousandSeparator={true}
                              className={
                                this.state.otherCharges.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="otherCharges"
                              name={this.state.otherCharges.name}
                              value={this.state.otherCharges.value}
                              onChange={this.onChange}
                              onBlur={this.addTotal}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              type="file"
                              className={
                                this.state.otherChargesFiles.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=""
                              name={this.state.otherChargesFiles.name}
                              // value={this.state.otherChargesFiles.value}
                              onChange={this.onChange}
                              multiple={true}
                            />
                          </div>

                          <div className="container">
                            {this.state.otherChargesFiles.value != "" ? (
                              <React.Fragment>
                                {Array.from(
                                  this.state.otherChargesFiles.value
                                ).some((item, index) => {
                                  return (
                                    extArray.indexOf(
                                      item.name.split(".").slice(-1)[0]
                                    ) == -1
                                  );
                                }) == true ? (
                                  <p className="text-danger">
                                    {" "}
                                    Only PNG , JPEG , PDF allowed{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}

                            {this.state.otherChargesFiles.value != ""
                              ? Array.from(
                                  this.state.otherChargesFiles.value
                                ).map((item, index, array) => {
                                  return (
                                    <React.Fragment>
                                      <span
                                        className={` mx-1  badge ${
                                          extArray.indexOf(
                                            item.name.split(".").slice(-1)[0]
                                          ) > -1
                                            ? "badge-primary"
                                            : "badge-danger"
                                        } `}
                                      >
                                        {item.name}
                                        <CgCloseO
                                          style={{
                                            float: "right",
                                            justifyContent: "Center",
                                            marginLeft: "3px",
                                          }}
                                          title="delete special file"
                                          className="closeButton"
                                          onClick={(e) =>
                                            this.chargesDelete(
                                              this.state.otherChargesFiles.name,
                                              index,
                                              array
                                            )
                                          }
                                        />
                                      </span>
                                    </React.Fragment>
                                  );
                                })
                              : ""}
                          </div>
                        </div>

                        {/* otherChargesFiles   ends*/}

                        {/* total sum starts  */}

                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-4">Total</div>

                          <div className="col-md-8">
                            <input
                              type="text"
                              className={
                                this.state.totalSum.length === 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder=" Net Total "
                              //    name={this.state.totalSum.name}
                              value={this.state.totalSum}
                              // onChange={this.onChange}
                            />
                          </div>
                        </div>

                        {/* total sum ends here  */}

                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                {" "}
                                <strong> Description </strong>{" "}
                              </label>
                              <textarea
                                rows={5}
                                type="text"
                                className={
                                  this.state.description.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder=""
                                name={this.state.description.name}
                                value={this.state.description.value}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                {" "}
                                <strong> HR Dealing officer </strong>{" "}
                              </label>

                              <Typeahead
                                id="ta-recipient"
                                labelKey={(option) =>
                                  `${option.name} - ${option.employeeNumber}`
                                }
                                name={to.name}
                                value={to.value}
                                multiple={false}
                                options={to.options}
                                onChange={(e) =>
                                  this.typeaheadOnChange(to.name, e)
                                }
                                placeholder="Send to"
                                isInvalid={to.error.length > 0}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {showModal && (
                        <ModalWindow
                          title="Add pateint Name"
                          backdrop={false}
                          toggleModal={this.onCancel}
                        >
                          <PatientName
                            onSubmit={this.onAddPatientName}
                            onCancel={this.onCancel}
                          />
                        </ModalWindow>
                      )}

                      
                      <div className="flex justify-content-end">
                        <Link
                          to={CONSTANT.component.userFileList.url}
                          className="btn cancel-button btn-sm btn-sm px-3"
                        >
                          Cancel
                        </Link>
                        <button
                          onClick={this.onSubmit}
                          className="btn submit-button btn-sm ml-3 px-3"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {/* Same as */}

        <ToastContainer />

        {showLoader && <Loader />}
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let allChargesValues = [
      this.state.consultationCharges.value,
      this.state.medicineCost.value,
      this.state.pathologicalCharges.value,
      this.state.physiothrapyCharges.value,
      this.state.operationCharges.value,
      this.state.operationTheatreCharges.value,
      this.state.anaesthesiaCharges.value,
      this.state.roomIcuCharges.value,
      this.state.injectionCharges.value,
      this.state.disposalCharges.value,
      this.state.dentalCharges.value,
      this.state.otherCharges.value,
    ];
    let sum = 0;
    for (var i = 0; i < allChargesValues; i++) {
      sum += allChargesValues[i];
    }
  }

  dltPatient = (name, index) => {
    const { patientNames } = this.state;
    patientNames.value.splice(index, 1);
    onChange(this, this.state.patientNames.name, this.state.patientNames.value);
  };

  onAddPatientName = (pateints) => {
    onChange(this, this.state.patientNames.name, pateints);
    this.setState({ showModal: false });
  };

  onCancel = () => {
    this.setState({ showModal: false });
  };

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  chargesDelete = (name, index, array) => {
    if (name == this.state.consultationChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.consultationChargesFiles.name, array);
    }

    if (name == this.state.medicineCostFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.medicineCostFiles.name, array);
    }

    if (name == this.state.pathologicalChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.pathologicalChargesFiles.name, array);
    }

    if (name == this.state.physiothrapyChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.physiothrapyChargesFiles.name, array);
    }

    if (name == this.state.operationChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.operationChargesFiles.name, array);
    }

    if (name == this.state.anaesthesiaChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.anaesthesiaChargesFiles.name, array);
    }

    if (name == this.state.roomIcuChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.roomIcuChargesFiles.name, array);
    }

    if (name == this.state.injectionChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.injectionChargesFiles.name, array);
    }

    if (name == this.state.disposalChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.disposalChargesFiles.name, array);
    }

    if (name == this.state.dentalChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.dentalChargesFiles.name, array);
    }

    if (name == this.state.otherChargesFiles.name) {
      let dltedItem = array.splice(index, 1);
      onChange(this, this.state.otherChargesFiles.name, array);
    }
  };

  onChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    const st = this.state;

    if (name === this.state.attachments.name) {
      value = e.target.files;
    }

    if (name == this.state.specialFile.name) {
      value = e.target.files;
      onChange(this, this.state.specialFile.name, value[0].name);
    }

    if (name === this.state.cronicFile.name) {
      value = e.target.files;
      onChange(this, this.state.cronicFile.name, value[0].name);
    }

    if (name == this.state.consultationChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.medicineCostFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.medicineCostFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.physiothrapyChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.pathologicalChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.operationChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.operationTheatreChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.anaesthesiaChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.roomIcuChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.injectionChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.disposalChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.dentalChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.otherChargesFiles.name) {
      value = e.target.files;
    }

    if (name == this.state.consultationCharges.name) {
    }

    if (name == this.state.medicineCost.name) {
    }

    onChange(this, name, value);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevState.consultationCharges.value !=
      this.state.consultationCharges.value
    ) {
    }

    if (prevState.medicineCost.value != this.state.medicineCost.value) {
      //  onChange( this , this.state.totalSum.name , this.state.medicineCost.value  )
    }
  }

  onBlur = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === this.state.fileNumber.name) {
      checkFileNumber(value).then((res) => {
        this.setState({
          isFileNumberValid: !(res.result.length > 0),
        });
      });
    }
  };

  typeaheadOnChange = (name, e) => {
    let value = e;
    if (e.length > 0 && e[0].customOption) {
      value = [{ name: e[0].name }];
    }
    onChange(this, name, value);
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (!this.state.showLoader) {
      if (validateForm(this)) {
        // this.setState({ showLoader: true });

        const st = this.state;
        let uploadId = Math.random();

        const model = {
          category: st.categoryList.value,
          categoryValue: st.categoryValue.value,
          userDetail: st.userDetail.value.code,
          diagnosis: st.diagnosis.value,
          patientNames: st.patientNames.value,
          bankAccount: st.bankAccount.value,
          bankName: st.bankName.value,
          ifsc: st.ifsc.value,
          consultationCharges: st.consultationCharges.value,
          medicineCost: st.medicineCost.value,
          pathologicalCharges: st.pathologicalCharges.value,
          physiothrapyCharges: st.physiothrapyCharges.value,
          operationCharges: st.operationCharges.value,
          operationTheatreCharges: st.operationTheatreCharges.value,
          anaesthesiaCharges: st.anaesthesiaCharges.value,
          roomIcuCharges: st.roomIcuCharges.value,
          injectionCharges: st.injectionCharges.value,
          disposalCharges: st.disposalCharges.value,
          dentalCharges: st.dentalCharges.value,
          otherCharges: st.otherCharges.value,
          totalSum: st.totalSum,
          description: st.description.value,
          pendingWith: st.to.value,
        };

        addMedicalClaim(model).then(async (res) => {
          if (res.status === CONSTANT.static.apiStatus.success) {
            if (
              (st.consultationChargesFiles.value.length ||
                st.consultationChargesFiles.value.length ||
                st.medicineCostFiles.value.length ||
                st.pathologicalChargesFiles.value.length ||
                st.physiothrapyChargesFilesesFiles.value.length ||
                st.operationChargesFiles.value.length ||
                st.operationTheatreChargesFiles.value.length ||
                st.anaesthesiaChargesFiles.value.length ||
                st.roomIcuChargesFiles.value.length ||
                st.injectionChargesFiles.value.length ||
                st.disposalChargesFiles.value.length ||
                st.dentalChargesFiles.value.length ||
                st.otherChargesFiles.value.length) > 0
            ) {
              let model = {
                medicalId: res.result.medicalId,
                pendingWith: parseInt(res.result.pendingWith),
              };

              await chronicFile(
                st.cronicFile.value,
                model,
                this.state.cronicFile.name
              );
              await specialFile(
                st.specialFile.value,
                model,
                this.state.specialFile.name
              );
              await consultationChargesFiles(
                st.consultationChargesFiles.value,
                model,
                this.state.consultationCharges.name
              );
              await medicineCostFiles(
                st.medicineCostFiles.value,
                model,
                this.state.medicineCost.name
              );
              await pathologicalChargesFiles(
                st.pathologicalChargesFiles.value,
                model,
                this.state.pathologicalCharges.name
              );
              await physiothrapyChargesFiles(
                st.physiothrapyChargesFiles.value,
                model,
                this.state.physiothrapyCharges.name
              );
              await operationChargesFiles(
                st.operationChargesFiles.value,
                model,
                this.state.operationCharges.name
              );
              await operationTheatreChargesFiles(
                st.operationTheatreChargesFiles.value,
                model,
                this.state.operationTheatreCharges.name
              );
              await anaesthesiaChargesFiles(
                st.anaesthesiaChargesFiles.value,
                model,
                this.state.anaesthesiaCharges.name
              );
              await roomIcuChargesFiles(
                st.roomIcuChargesFiles.value,
                model,
                this.state.roomIcuCharges.name
              );
              await injectionChargesFiles(
                st.injectionChargesFiles.value,
                model,
                this.state.injectionCharges.name
              );
              await disposalChargesFiles(
                st.disposalChargesFiles.value,
                model,
                this.state.disposalCharges.name
              );
              await dentalChargesFiles(
                st.dentalChargesFiles.value,
                model,
                this.state.dentalCharges.name
              );
              await otherChargesFiles(
                st.otherChargesFiles.value,
                model,
                this.state.otherCharges.name
              );

              toast.success(" Applied Successfully ", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });

              setTimeout(() => {
                //  this.props.history.push(constant.component.listMedicalClaim.url);
              }, 4000);
            }
          } else {
            this.setState({ showLoader: false });
            alert(res.error);
          }
        });
      }
    }
  };

  HandleDraft = (e) => {
    const isSure = window.confirm("Are you sure, you want to Save this?");
    if (isSure) {
      const id = parseInt(e.target.dataset.id, 10);
      autoSave(id).then((res) => {
        if (res.status === CONSTANT.static.apiStatus.success) {
          window.location.reload();
        } else {
          alert(res.error.message);
        }
      });
    }
  };
}

export default AddMedicalClaim;
